<script setup>
import Icon from 'next/icon/Icon.vue';

defineProps({
  label: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  collapsible: {
    type: Boolean,
    default: false,
  },
  expanded: {
    type: Boolean,
    default: false,
  },
  headerAction: {
    type: Function,
    default: null,
  },
});

const emit = defineEmits(['toggle']);
</script>

<template>
  <div
    class="relative flex items-center rounded-lg h-8 text-n-slate-10 select-none"
    :class="
      collapsible
        ? 'w-full cursor-pointer hover:bg-n-alpha-2 hover:text-n-slate-11'
        : 'pointer-events-none'
    "
  >
    <button
      v-if="collapsible"
      type="button"
      :aria-expanded="expanded"
      class="absolute inset-0 flex items-center gap-2 w-full min-w-0 h-full px-2 py-1.5 rounded-lg text-inherit"
      :class="{ 'ltr:pr-10 rtl:pl-10': headerAction && expanded }"
      @click="emit('toggle')"
    >
      <Icon v-if="icon" :icon="icon" class="size-4" />
      <span class="text-sm font-medium leading-5 flex-grow text-start">
        {{ label }}
      </span>
      <span v-show="expanded" class="i-lucide-chevron-up size-3" />
    </button>
    <div
      v-else
      class="absolute inset-0 flex items-center gap-2 w-full min-w-0 h-full px-2 py-1.5 rounded-lg text-inherit"
    >
      <Icon v-if="icon" :icon="icon" class="size-4" />
      <span class="text-sm font-medium leading-5 flex-grow text-start">
        {{ label }}
      </span>
    </div>
    <component
      :is="headerAction"
      v-if="headerAction"
      v-show="expanded"
      class="absolute z-10 ltr:right-2 rtl:left-2"
    />
  </div>
</template>
